import { Controller } from "@hotwired/stimulus"

// Fires a fire-and-forget analytics beacon when a share link on the
// smoothie show page is clicked. The links themselves are untouched —
// they still navigate straight to X/Facebook/Pinterest in a new tab
// (target="_blank"), so the POST below never races that navigation.
//
// Usage:
//   data-controller="smoothie-share"
//   data-smoothie-share-track-url-value="<%= breakfast_smoothie_share_track_path(@smoothie.slug) %>"
//   <a data-action="click->smoothie-share#track" data-channel="twitter" ...>
export default class extends Controller {
  static values = { trackUrl: String }

  track(event) {
    const channel = event.currentTarget.dataset.channel
    if (!channel || !this.hasTrackUrlValue) return

    fetch(this.trackUrlValue, {
      method: "POST",
      headers: this._jsonHeaders(),
      body: JSON.stringify({ channel })
    }).catch(() => {
      // Best-effort only — a failed beacon must never block the share click.
    })
  }

  _jsonHeaders() {
    return {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": this._csrfToken()
    }
  }

  _csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
